export interface ICalculatorMcfValues {
  regionId: string;
  realEstateType: ECalculatorRealEstateType;
  objectType: ECalculatorObjectType;
  loanTerm: number;
  objectCost: number;
  downPayment: number;
  benefitProgram: ECalculatorBenefitProgram;
  typeOfEmployment: ECalculatorEmploymentType;
  payrollBank?: string;
  incomeConfirm: ECalculatorIncomeConfirmation;
}

export enum ECalculatorBenefitProgram {
  /** Все программы (отсутствие выбранного фильтра) **/
  'All' = 'all',
  /** Семейная **/
  'Family' = 'family',
  /** ИТ-ипотека **/
  'It' = 'it',
  /** Без программы **/
  'NoProgram' = 'noProgram',
}

export enum ECalculatorRealEstateType {
  /** Новостройка **/
  'NewBuilding' = 'newBuilding',
  /** Вторичка **/
  'Secondary' = 'secondary',
  /** Строительство дома **/
  'HouseBuilding' = 'houseBuilding',
}

export enum ECalculatorEmploymentType {
  /** Владелец бизнеса **/
  'BusinessOwner' = 'businessOwner',
  /** Полная занятость **/
  'Employee' = 'employee',
  /** ИП **/
  'Entrepreneur' = 'entrepreneur',
  /** Самозанятый **/
  'SelfEmployed' = 'selfEmployed',
}

export enum ECalculatorIncomeConfirmation {
  /** С подтверждением **/
  'Confirmation' = 'confirmation',
  /** Без подтверждения **/
  'NoConfirmation' = 'noConfirmation',
}

export enum ECalculatorObjectType {
  /** Апартаменты **/
  'Apartments' = 'apartments',
  /** Квартира **/
  'Flat' = 'flat',
  /** Дом **/
  'House' = 'house',
}

export type TCalculatorAnalytics = { eventName: string; extra?: ICalculatorMcfValues };

export type TCalculatorMcfErrorsItem = {
  field: keyof ICalculatorMcfValues;
  label: string;
  message: string;
};

export type TCalculatorErrors = TCalculatorMcfErrorsItem[];
